import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import QuoteHero from './components/QuoteHero';
import PositioningSection from './components/PositioningSection';
import ServicesSection from './components/ServicesSection';
import LocationsSection from './components/LocationsSection';
import ProcessSection from './components/ProcessSection';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

const App: React.FC = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden selection:bg-[#D4AF37] selection:text-white">
      <Navbar />
      <main className="flex-grow">
        <Hero onChecklistClick={() => setIsContactModalOpen(true)} />
        <ProblemSection />
        <QuoteHero />
        <PositioningSection />
        <ServicesSection />
        <LocationsSection />
        <ProcessSection />
      </main>
      <Footer />
      
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </div>
  );
};

export default App;